<div class="fullScreen">
  <headband [accountName]="accountName" [maxVoters]="maxVoters" [hasHotline]="hasHotline"
    (hotlinePopupChange)="hotlinePopup = $event" (optionsPopupChange)="changeSubscription()"
    (buyPopupEvent)="shouldBuyCredits = $event"></headband>
  <!-- <div class="account-header to">
    <div *ngIf="maxVoters === 10"
      style="display: flex; justify-content: space-between; height: 40px; align-items: center;">
      <span>
        <p class="banner-text" id="txt">
          {{'POLL-DASHBOARD.HEADBAND.MESSAGE-CREATION' | translate}}
        </p>
      </span>
      <div style="height: 40px; margin-right: 24px; display: flex; align-items: center;">
        <span>
          <p style="margin: 0;" class="banner-text" id="txt2">
            {{accountName}}
          </p>
        </span>
        <img src="assets/power_settings_new_24px.svg" class="power-button" (click)="logout()"
          style="cursor: pointer; margin-left: 20px;" loading="lazy">
      </div>
    </div>

    <div *ngIf="maxVoters > 10"
      style="margin-right: 24px; height: 100%; display: flex; justify-content: space-between; align-items: center;">
      <button *ngIf="!hasHotline else hotline" class="button-change" [ngClass]="['green-button', 'button-change']"
        (click)="triggerHotlinePopup()">
        {{'POLL-DASHBOARD.HEADBAND.HOTLINE' | translate}}
      </button>
      <ng-template #hotline>
        <p class="banner-text hotline-display">
          {{'POLL-DASHBOARD.HEADBAND.PHONE' | translate}}
        </p>
      </ng-template>

      <span class="right-container">
        <p class="banner-text" *ngIf="licenseTime == 'D'">
          {{accountName}} - {{'POLL-DASHBOARD.HEADBAND.EVENTS' | translate}}
        </p>
        <p class="banner-text" *ngIf="licenseTime == 'DM'">
          {{accountName}} - {{eventCounter}} {{'POLL-DASHBOARD.HEADBAND.PACK' | translate}}
        </p>
        <p class="banner-text" *ngIf="licenseTime == 'Y'">
          {{accountName}} - {{'POLL-DASHBOARD.HEADBAND.YEARLY' | translate}}
        </p>
        <button *ngIf="maxVoters > 10 && !licencesReady"
          [ngClass]="['inactive-large-button']">{{'POLL-DASHBOARD.HEADBAND.LOADING' | translate}}</button>
        <button *ngIf="maxVoters > 10 && licencesReady" [ngClass]="['green-button', 'button-change']"
          (click)="changeSubscription()">{{'POLL-DASHBOARD.HEADBAND.CHANGE' | translate}}</button>
        <img src="assets/power_settings_new_24px.svg" (click)="logout()" loading="lazy"
          style="cursor: pointer; margin-left: 20px; height: 24px; width:24px;">
      </span>
    </div>
  </div> -->
  <div class="left-header">
    <img *ngIf="image && image.trim() !== ''; else defaultLogo" [src]="image" id="logo" data-cy="back-btn"
      (click)="navigateHome()">
    <ng-template #defaultLogo>
      <img src="assets/v8te.png" id="logo" data-cy="back-btn" (click)="navigateHome()">
    </ng-template>
    <div class="title-container">
      <div class="title-container-sub">
        <div class="arrow-container pointer" style="margin-right: 10px;" (click)="navigateArrow()">
          <img class="arrow" src="assets/arrow-left.svg">
          <p class="dark-blue text-sm" style="margin: 0;">Retour</p>
        </div>

        <div id="poll-status" class="flex flex-column dark-blue gap-10">
          <div class="flex gap-10 align-items-center">
            <img *ngIf="opened && !suspended" src="assets/ongoing_poll_icon.svg" class="icon-inline">
            <img *ngIf="!opened" src="assets/calendar-crossed.svg" class="icon-inline">
            <img *ngIf="suspended && opened" src="assets/suspend-icon.svg" class="icon-inline">

            <p class="flex align-items-center gap-5 text-md no-margin">Statut du scrutin </p>
            <p class="flex align-items-center gap-5 text-lg bold no-margin">
              {{opened ? 'EN COURS...' : 'PROGRAMMÉ'}}
            </p>
          </div>
          <div>
            <p class="poll-info text-md dark-blue" data-cy="details-ongoing">
              <span id="exclamation">!</span>
              <span *ngIf="isLive">{{'POLL-CREATION.FORM.LABEL-LIVE' | translate}}</span>
              <span *ngIf="!isLive">{{'POLL-CREATION.FORM.LABEL-PLANNED' | translate}}</span>,
              <span *ngIf="!isPublic">{{'COMMON.LOW-SECRET' | translate}}</span>
              <span *ngIf="isPublic">{{'COMMON.LOW-PUBLIC' | translate}}</span>,
              <span *ngIf="SMSOption && !is2FA">{{'COMMON.LOW-MAIL-SMS' | translate}}</span>
              <span *ngIf="SMSOption && is2FA">{{'COMMON.LOW-2FA' | translate}}</span>
              <span *ngIf="!SMSOption">{{'COMMON.LOW-MAIL' | translate}}</span>
              <span *ngIf="isAssessors">{{'COMMON.ASS-INVITE' | translate}}</span>
            </p>
          </div>
        </div>

        <!-- <h3 class="title" data-cy="event-title-ongoing">{{title}}</h3> -->
      </div>
      <p></p>
    </div>
  </div>
  <div></div>
</div>

<!-- Popups si l'utilisateur a déjà un forfait -->
<!-- <vc-warning-popup class="YA" *ngIf="shoulDisplayChangePopup && smsAdditionalOption" [isAssoc]="clientType == 'assoc'"
  (isClosed)="dismissChangePopup()" title="{{'PRICE-DETAILS.SMS-ON-CHANGE' | translate}}" [noSMSButton]="true"
  [separator]="true" [SMSOffers]="smsAdditionalOption" (SMSOptionEmitter)="setSMSOption($event)"
  (endDetailsPopup)="dismissInitialPopup()">
</vc-warning-popup> -->

<!-- Popup to select an SMS option with the package -->
<vc-warning-popup class="SMS" *ngIf="smsAdditionalOption && !shoulDisplayChangePopup" [SMSOffers]="smsAdditionalOption"
  title="{{'PRICE-DETAILS.SMS-TITLE' | translate}}" [separator]="true" [noSMSButton]="true"
  (SMSOptionEmitter)="setSMSOption($event)" (endDetailsPopup)="dismissInitialPopup()" [isAssoc]="isAssoc">
</vc-warning-popup>

<!-- Popups si l'utilisateur souhaite acheter un forfait -->
<!-- <vc-warning-popup class="hotline" *ngIf="hotlinePopup" [isAssoc]="clientType == 'assoc'"
  (isClosed)="dismissChangePopup()" title="{{'HOTLINE.HOTLINE-TEXT' | translate}}" [cancelButton]="true"
  [separator]="true" [hotline]="true" (hotlineOptionEmitter)="setHotlineOption($event)"
  (endDetailsPopup)="dismissInitialPopup()" [licenseTime]="licenseTime">
</vc-warning-popup> -->

<buy-options-popup *ngIf="hotlinePopup" (endDetailsPopup)="dismissInitialPopup()" [licenseTime]="licenseTime"
  [isAssoc]="clientType == 'assoc'" (isClosed)="dismissChangePopup()" [SMSOffers]="smsAdditionalOption"
  (SMSOptionEmitter)="setSMSOption($event)" (hotlineOptionEmitter)="setHotlineOption($event)"></buy-options-popup>


<vc-offers-popup *ngIf="shouldBuyCredits" [isAssoc]="isAssoc" source="{{'dashboard'}}" (freeTrial)="newPoll()"
  (isClosed)="dismissPayPopup($event)" (moreInfoEmitter)="displayMoreInfo($event)"
  (displaySMSEmitter)="shoulDisplayChangePopup = true"
  (selectedOffer)="licenseService.buyOffer($event)"></vc-offers-popup>

<!-- Popup to display more options -->
<vc-warning-popup *ngIf="moreOption" title="{{'PRICE-DETAILS.TITLE' | translate}}" [callButton]="true"
  [separator]="false" [cancelButton]="true" (endDetailsPopup)="openOffers($event)" [isAssoc]="isAssoc"
  [index]="selectedOffer"></vc-warning-popup>

<!-- Popup to get contacted by v8te for more information -->
<vc-warning-popup class="CONTACTED" *ngIf="getContacted" [index]="-1" (endDetailsPopup)="dismissInitialPopup()"
  title="{{'DETAILS-CONTACT.TITLE' | translate}}" [phoneInput]="true" [understoodEndButton]="true"
  (contactPhone)="getContactPhone($event)"></vc-warning-popup>